var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, FormHelperText, RadioGroup as MuiRadioGroup, } from '@mui/material';
import { styled } from '@mui/system';
import { Controller } from 'react-hook-form';
export function RadioGroup(_a) {
    var control = _a.control, rules = _a.rules, name = _a.name, children = _a.children, defaultValue = _a.defaultValue, className = _a.className;
    return (_jsx(Controller, { control: control, rules: rules, name: name, render: function (_a) {
            var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, name = _b.name, ref = _b.ref, _c = _a.fieldState, invalid = _c.invalid, isTouched = _c.isTouched, isDirty = _c.isDirty, error = _c.error, formState = _a.formState;
            return (_jsxs(FormControl, __assign({ className: className }, { children: [_jsx(MuiRadioGroup, __assign({ className: "contents", defaultValue: defaultValue, onChange: onChange, onBlur: onBlur, value: value || '', ref: ref, name: name }, { children: children })), error && _jsx(ErrorMessage, { children: error.message })] })));
        } }));
}
export default RadioGroup;
var ErrorMessage = styled(FormHelperText)(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.palette.error.main,
    });
});
